export type Status =
  | 'Places available'
  | 'Limited availability'
  | 'Sold out'
  | 'Join waiting list'

export interface ClassSession {
  id: string
  title: string
  sport: string
  ageGroup: string
  dayTime: string
  status: Status
  bookingUrl: string
  pricing?: string
}

export interface Venue {
  id: string
  name: string
  address: string
  sessions: ClassSession[]
}

export interface RegionData {
  name: string
  description: string
  venues: Venue[]
}

export const regionDatabase: Record<string, RegionData> = {
  derbyshire: {
    name: 'Derbyshire',
    description:
      'Browse our range of Olympian-led workshops and weekly classes across Derbyshire venues.',
    venues: [
      {
        id: 'v1',
        name: 'Derby Arena',
        address: 'Royal Way, Pride Park, Derby DE24 8JB',
        sessions: [
          {
            id: 's1',
            title: 'Beginners Badminton',
            sport: 'Badminton',
            ageGroup: 'Ages 5-8',
            dayTime: 'Saturdays, 09:00 - 10:00',
            status: 'Places available',
            bookingUrl: '#',
          },
          {
            id: 's2',
            title: 'Intermediate Badminton',
            sport: 'Badminton',
            ageGroup: 'Ages 9-12',
            dayTime: 'Saturdays, 10:00 - 11:30',
            status: 'Limited availability',
            bookingUrl: '#',
          },
          {
            id: 's3',
            title: 'Multi-Sports Holiday Camp',
            sport: 'Multi-Sports',
            ageGroup: 'Ages 5-11',
            dayTime: 'Mon-Fri (Half Term), 09:00 - 15:00',
            status: 'Places available',
            bookingUrl: '#',
          },
        ],
      },
      {
        id: 'v2',
        name: 'Repton School Sports Centre',
        address: 'Willington Road, Repton DE65 6FH',
        sessions: [
          {
            id: 's4',
            title: 'Advanced Badminton Academy',
            sport: 'Badminton',
            ageGroup: 'Ages 12-16',
            dayTime: 'Tuesdays, 18:00 - 20:00',
            status: 'Sold out',
            bookingUrl: '#',
          },
          {
            id: 's5',
            title: 'Junior Netball Skills',
            sport: 'Netball',
            ageGroup: 'Ages 8-11',
            dayTime: 'Thursdays, 17:00 - 18:00',
            status: 'Places available',
            bookingUrl: '#',
          },
        ],
      },
      {
        id: 'v3',
        name: 'Etwall Leisure Centre',
        address: 'Hilton Road, Etwall DE65 6HZ',
        sessions: [
          {
            id: 's6',
            title: 'Mini Stars Multi-Sports',
            sport: 'Multi-Sports',
            ageGroup: 'Ages 3-5',
            dayTime: 'Sundays, 09:00 - 09:45',
            status: 'Join waiting list',
            bookingUrl: '#',
          },
        ],
      },
    ],
  },
  hampshire: {
    name: 'Hampshire',
    description:
      'Discover our expert sports coaching sessions available at our Hampshire locations.',
    venues: [],
  },
  hertfordshire: {
    name: 'Hertfordshire',
    description:
      'Join our Olympian-led coaching programmes across Hertfordshire.',
    venues: [
      {
        id: 'v5',
        name: "St. Helen's School Sports Centre",
        address: 'Eastbury Road, Northwood, HA6 1AF',
        sessions: [
          {
            id: 's9',
            title: 'Netball Workshop',
            sport: 'Netball',
            ageGroup: '8–15 years old',
            dayTime: 'Wed 8th & Thu 9th April 2026, 9:30am – 12:30pm',
            status: 'Places available',
            bookingUrl: '#',
            pricing: '1 Day £35 · 2 Days £65',
          },
          {
            id: 's10',
            title: 'Badminton Workshop',
            sport: 'Badminton',
            ageGroup: '8–15 years old',
            dayTime: 'Wed 8th & Thu 9th April 2026, 1:30pm – 4:30pm',
            status: 'Places available',
            bookingUrl: '#',
            pricing: '1 Day £37.50 · 2 Days £70',
          },
        ],
      },
    ],
  },
}

export const getStatusStyles = (status: Status): string => {
  switch (status) {
    case 'Places available':
      return 'bg-green-50 text-green-700 border-green-200'
    case 'Limited availability':
      return 'bg-amber-50 text-amber-700 border-amber-200'
    case 'Sold out':
      return 'bg-red-50 text-red-700 border-red-200'
    case 'Join waiting list':
      return 'bg-gray-100 text-gray-700 border-gray-200'
    default:
      return 'bg-gray-100 text-gray-700 border-gray-200'
  }
}
